module.exports = "<svg viewBox=\"0 0 95.6 146\"><path fill=\"#1E1E1C\" d=\"M47.7 0C20 0-1.4 23.8.1 51.4c1.7 33.5 26.9 74 44.6 93.2 1.7 1.8 4.5 1.8 6.2 0C69.3 124.7 95.6 82 95.6 47.8 95.6 21.4 74.1 0 47.7 0zm.1 58.6c-6 0-10.8-4.9-10.8-10.8S41.8 37 47.8 37s10.8 4.9 10.8 10.8-4.8 10.8-10.8 10.8z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/map-marker.svg
// module id = 236
// module chunks = 1